import { render, staticRenderFns } from "./ChooseActionsReadOnlyView.vue?vue&type=template&id=7a928d8c&scoped=true&"
import script from "./ChooseActionsReadOnlyView.vue?vue&type=script&lang=js&"
export * from "./ChooseActionsReadOnlyView.vue?vue&type=script&lang=js&"
import style0 from "./ChooseActionsReadOnlyView.vue?vue&type=style&index=0&id=7a928d8c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7a928d8c",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!/app/node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib'
import { VLayout } from 'vuetify/lib'
import { VToolbar } from 'vuetify/lib'
installComponents(component, {VCard,VLayout,VToolbar})
